// Round-trip export: reconstruct the Markdown source from the retained source blocks
// so a human's view can be copied back to the agent as a prompt. BYO-HTML pagelets have
// no source blocks — fall back to the rendered text so Copy never yields an empty clipboard.
import { dedent } from './util'

export function collectMarkdown(): string {
  const blocks = document.querySelectorAll<HTMLScriptElement>(
    'script[type="text/markdown"][data-pagelet="markdown"]',
  )
  const md = Array.from(blocks)
    .map((b) => dedent(b.textContent || ''))
    .join('\n\n')
    .trim()
  if (md) return md
  const root = document.querySelector('.pagelet-prose') ?? document.querySelector('main') ?? document.body
  return (root.textContent || '').replace(/\n{3,}/g, '\n\n').trim()
}
